/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PriceTransparencyLevelEnum =
  (typeof PriceTransparencyLevelEnum)[keyof typeof PriceTransparencyLevelEnum];

export const PriceTransparencyLevelEnum = {
  full: 'full',
  full_condensed: 'full_condensed',
  lite_condensed: 'lite_condensed',
  none: 'none',
} as const;
